import { isDefined } from 'utils/tsHelpers';
import { useTranslation } from '../useTranslation';
import type { ConditionalContent } from '../../domain';

const hasContent = (input?: string) => isDefined(input) && input.length > 0;

export const useValidateConditionalContentLength = () => {
  const { t } = useTranslation();

  return (conditionalContent?: ConditionalContent) => {
    const isContentLengthValid =
      hasContent(conditionalContent?.ifClause.content) ||
      hasContent(conditionalContent?.defaultContent) ||
      conditionalContent?.elseIfClauses.some((clause) => hasContent(clause.content));

    if (!isContentLengthValid) {
      return t('conditionalContent.contentLengthError');
    }
  };
};
